import { createFileRoute } from "@tanstack/react-router";

import { Services } from "../../../../Components/Agent/Services";

export const Route = createFileRoute("/_authenticated/_agentLayout/stations/")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Services />;
}
